import DeleteIcon from "@mui/icons-material/DeleteOutlineRounded";
import {
  CircularProgress,
  IconButton,
  Paper,
  Stack,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import FileIcon from "@entrilia/shared/components/FileIcon";
import TableWithActions from "@entrilia/shared/components/TableWithActions";
import { formatFileSize, getFileExtension } from "@entrilia/shared/utilities/fileHelper";
import { useImportCsvDataContext } from "../ImportCsvDataContext";
import type { ImportSourceFileInfo } from "../importCsvDataPageState";
import { deleteSourceFileAction } from "../importCsvDataPageState";

interface Props {
  sourceFile: ImportSourceFileInfo;
}

const ImportSourceFileTable = ({ sourceFile }: Props) => {
  const { setPageState } = useImportCsvDataContext();

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ width: "100%" }}>
      <TableWithActions>
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell sx={{ width: 120 }}>Size</TableCell>
            <TableCell sx={{ width: 64 }}></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>
              <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
                {sourceFile.status !== "in_progress" && (
                  <FileIcon fileExtension={getFileExtension(sourceFile.fileInfo.fileName)} />
                )}
                {sourceFile.status === "in_progress" && (
                  <CircularProgress size={20} color="secondary" sx={{ flexShrink: 0 }} />
                )}
                <Stack>
                  <Typography noWrap>{sourceFile.fileInfo.fileName}</Typography>
                  {sourceFile.status === "error" && sourceFile.errorMessage && (
                    <Typography variant="caption" color="error">
                      {sourceFile.errorMessage}
                    </Typography>
                  )}
                </Stack>
              </Stack>
            </TableCell>
            <TableCell>{formatFileSize(sourceFile.fileInfo.fileSize)}</TableCell>
            <TableCell className="table-row-actions">
              {sourceFile.status !== "in_progress" && (
                <IconButton onClick={() => setPageState(deleteSourceFileAction(sourceFile.targetOptionKey))}>
                  <DeleteIcon color="error" />
                </IconButton>
              )}
            </TableCell>
          </TableRow>
        </TableBody>
      </TableWithActions>
    </TableContainer>
  );
};

export default ImportSourceFileTable;
